import { render, staticRenderFns } from "./PageResultsIndicator.vue?vue&type=template&id=7f5295e8&scoped=true"
import script from "./PageResultsIndicator.vue?vue&type=script&lang=js"
export * from "./PageResultsIndicator.vue?vue&type=script&lang=js"
import style0 from "./PageResultsIndicator.vue?vue&type=style&index=0&id=7f5295e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5295e8",
  null
  
)

export default component.exports